import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import { vantComponent } from './plugins/vant'
import Empty from '@/components/Empty'
import SelectMultiple from '@/components/SelectMultiple'
import TimePicker from '@/components/TimePicker'
import 'vant/lib/index.less'
import '@/assets/styles/global.less'
import '@vant/touch-emulator';
import { ImagePreview } from 'vant';

Vue.use(ImagePreview);

// vant组件按需加载
vantComponent.forEach(item => {
  Vue.use(item)
})

Vue.config.productionTip = false

Vue.component('Empty', Empty)
Vue.component('SelectMultiple', SelectMultiple)
Vue.component('TimePicker', TimePicker)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')